import { fadeInUp } from '@/constants/motions';
import { Icon } from '@iconify/react';
import cx from 'classnames';
import { motion } from 'framer-motion';
import Link from 'next/link';
import ConstructionIcon from '@/components/icons/ConstructionIcon';
import EngineeringAndDesignIcon from '@/components/icons/EngineeringAndDesignIcon';
import IndustrialProductSalesIcon from '@/components/icons/IndustrialProductSalesIcon';
import ManpowerIcon from '@/components/icons/ManpowerIcon';

export default function FloatingService({ text, url, icon }) {
  let CustomIcon;

  if (icon == 'ConstructionIcon') {
    CustomIcon = ConstructionIcon;
  }
  if (icon == 'EngineeringAndDesignIcon') {
    CustomIcon = EngineeringAndDesignIcon;
  }
  if (icon == 'IndustrialProductSalesIcon') {
    CustomIcon = IndustrialProductSalesIcon;
  }
  if (icon == 'ManpowerIcon') {
    CustomIcon = ManpowerIcon;
  }

  return (
    <motion.div className="relative" variants={fadeInUp}>
      <Link href={url}>
        <a
          className={cx(
            'group flex h-full items-center justify-center gap-2 rounded-lg bg-gradient-to-b from-neutral-50 to-neutral-100 p-4 text-primary-500 transition-transform duration-200 ease-in hover:absolute hover:inset-0 hover:z-30 hover:scale-105 hover:from-primary-400 hover:to-primary-500 hover:text-white hover:shadow-lg focus-visible:outline-dashed focus-visible:outline-primary-200 md:p-8 md:shadow-lg'
          )}
        >
          <div className="flex flex-col items-center gap-x-4 gap-y-2 text-center md:flex-row md:text-left">
            {Icon && (
              <CustomIcon className="h-14 shrink-0 fill-current text-primary-500 group-hover:h-16 group-hover:text-white xl:h-20" />
            )}
            <h4 className="text-lg font-medium leading-tight group-hover:text-base xl:text-xl">
              {text}
            </h4>
          </div>
          <Icon
            className="hidden shrink-0 md:group-hover:block"
            height="28"
            icon="fluent:chevron-circle-right-12-filled"
          />
        </a>
      </Link>
    </motion.div>
  );
}
